"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TrainingModel = void 0;
const chain_1 = __importDefault(require("../../../../Util/chain"));
const asFloat_1 = __importDefault(require("../../../../Util/asFloat"));
class TrainingModel {
    constructor(cache, logger) {
        this.addTrainings = async (customerId, trainings) => {
            const promises = [];
            for (let i = 0; i < trainings.length; i++) {
                const trainingDay = trainings[i];
                const key = this.customerDateKey(customerId, trainingDay.date);
                this.logger.log(`Training for ${customerId} on ${trainingDay.date} is being saved`);
                promises.push(this.cache.setObject(key, trainingDay.training).asPromise());
            }
            await (0, chain_1.default)(promises);
            this.logger.log(`Trainings for ${customerId} saved`);
        };
        this.customerDateKey = (customerId, date) => `${TrainingModel.TRAINING_DAY_DB}.${customerId}.${date}`;
        this.getDate = async (customerId, date, unit) => {
            try {
                const item = (await this.cache
                    .getObject(this.customerDateKey(customerId, date))
                    .asPromise());
                return {
                    ...item,
                    exercises: item.exercises.map((exercise) => {
                        return {
                            ...exercise,
                            sets: exercise.sets.map((set) => ({
                                ...set,
                                weight: !set.weight || unit === "kg"
                                    ? set.weight
                                    : (0, asFloat_1.default)(set.weight * 2.20462262, 2),
                            })),
                        };
                    }),
                };
            }
            catch (e) {
                return null;
            }
        };
        this.cache = cache;
        this.logger = logger;
    }
}
exports.TrainingModel = TrainingModel;
TrainingModel.TRAINING_DAY_DB = "Mock.Database.TRAINING_DB";
exports.default = TrainingModel;
//# sourceMappingURL=TrainingModel.js.map